const fromdata = [{
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择产品线",
		types: "",
		inputtype: "select",
		width: "300px",
		lablewith: "110px",
		btx: false,
		options: [],
	},
	{
		inputdata: "",
		title: "报量经销商",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "selectautocomplete",
		pt: true,
		width: "300px",
		lablewith: "110px",
		btx: false,
	},
	{
		inputdata: "",
		title: "订货经销商",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "selectautocompletemultiple",
		pt: true,
		width: "300px",
		btx: false,
		lablewith: "110px",
		options: [],
	},
];
export default fromdata;